// 일반적인 표 관련 유틸리티 함수들
import { insertHTMLAtEnd, scrollElementIntoView, setupGlobalTableHandlers } from './domUtils';
// 일반적인 표 HTML 생성
export const generateTableHTML = (rows: number = 2, cols: number = 2): string => {
  const tableId = `table-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  
  let tableHTML = `
    <div class="custom-table-wrapper" data-table-id="${tableId}">
      <table class="custom-table">
        <tbody>
  `;
  
  for (let i = 0; i < rows; i++) {
    tableHTML += '<tr>';
    for (let j = 0; j < cols; j++) {
      tableHTML += '<td contenteditable="true"></td>';
    }
    tableHTML += '</tr>';
  }
  
  tableHTML += `
        </tbody>
      </table>
      <div class="table-controls">
        <div class="add-row-btn" data-table-id="${tableId}">행 추가</div>
        <div class="delete-row-btn" data-table-id="${tableId}">행 삭제</div>
      </div>
    </div>
  `;
  
  return tableHTML;
};



// 일반적인 표 삽입 함수
export const insertTable = (
  contentRef: React.RefObject<HTMLDivElement>,
  rows: number = 2,
  cols: number = 2
): string => {
  if (!contentRef.current) return '';
  
  const tableHTML = generateTableHTML(rows, cols);
  
  // contentEditable div에 표 삽입
  insertHTMLAtEnd(contentRef, tableHTML);
  
  // 표 다음에 빈 줄 추가
  insertHTMLAtEnd(contentRef, '<p><br></p>');
  
  // 표가 제대로 삽입되었는지 확인하고 필요시 스크롤 조정
  setTimeout(() => {
    if (contentRef.current) {
      const tableWrapper = contentRef.current.querySelector(`[data-table-id="${tableHTML.match(/data-table-id="([^"]+)"/)?.[1]}"]`);
      scrollElementIntoView(tableWrapper);
        
      // 커서를 표 다음 빈 줄로 이동
      const range = document.createRange();
      const selection = window.getSelection();
      const lastParagraph = contentRef.current.querySelector('p:last-child');
      
      if (lastParagraph && selection) {
        range.setStart(lastParagraph, 0);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
        contentRef.current.focus();
      }
    }
  }, 100);
  
  // 업데이트된 HTML 내용을 반환
  return contentRef.current.innerHTML;
};

// 안전장치: 전역 함수 정의 (onclick 속성이 남아있을 경우를 대비)
setupGlobalTableHandlers();

// 일반적인 표 CSS 스타일
export const tableStyles = `
  /* 일반적인 표 스타일 */
  .custom-table-wrapper {
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }
  
  .custom-table {
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    margin-bottom: 0;
    table-layout: fixed;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .custom-table td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
    vertical-align: top;
    min-height: 20px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 0;
  }
  
  .custom-table td[contenteditable="true"] {
    cursor: text;
  }
  
  .custom-table td[contenteditable="true"]:focus {
    outline: 2px solid #1890ff;
    background-color: #f0f8ff;
  }
  
  .custom-table-wrapper .table-controls {
    margin-top: 8px;
    text-align: center;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
  }
  
  .custom-table-wrapper .add-row-btn {
    margin: 4px;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    background-color: #52c41a;
    color: white;
    outline: none;
    user-select: none;
    pointer-events: auto;
    display: inline-block;
    text-align: center;
    transition: background-color 0.2s;
  }
  
  .custom-table-wrapper .add-row-btn:hover {
    background-color: #389e0d;
  }
  
  .custom-table-wrapper .add-row-btn:active {
    background-color: #237804;
  }
  
  .custom-table-wrapper .delete-row-btn {
    margin: 4px;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    background-color: #ff4d4f;
    color: white;
    outline: none;
    user-select: none;
    pointer-events: auto;
    display: inline-block;
    text-align: center;
    transition: background-color 0.2s;
  }
  
  .custom-table-wrapper .delete-row-btn:hover {
    background-color: #cf1322;
  }
  
  .custom-table-wrapper .delete-row-btn:active {
    background-color: #a8071a;
  }
  

`; 